import { render, staticRenderFns } from "./captions.vue?vue&type=template&id=78f0754a"
import script from "./captions.vue?vue&type=script&lang=js"
export * from "./captions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports